export default "__VITE_ASSET__j8AXpm3b__"